import { css } from 'lit';export default css`



*,
::before,
::after {
  box-sizing: border-box;
  
  border-width: 0;
  
  border-style: solid;
  
  border-color: #e5e7eb;
  
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5;
  
  -webkit-text-size-adjust: 100%;
  
  -moz-tab-size: 4;
  
  -o-tab-size: 4;
     tab-size: 4;
  
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  
  font-feature-settings: normal;
  
  font-variation-settings: normal;
  
}



body {
  margin: 0;
  
  line-height: inherit;
  
}



hr {
  height: 0;
  
  color: inherit;
  
  border-top-width: 1px;
  
}



abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}



h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}



a {
  color: inherit;
  text-decoration: inherit;
}



b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  
  font-size: 1em;
  
}



small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}



table {
  text-indent: 0;
  
  border-color: inherit;
  
  border-collapse: collapse;
  
}



button,
input,
optgroup,
select,
textarea {
  font-family: inherit;
  
  font-size: 100%;
  
  font-weight: inherit;
  
  line-height: inherit;
  
  color: inherit;
  
  margin: 0;
  
  padding: 0;
  
}



button,
select {
  text-transform: none;
}



button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button;
  
  background-color: transparent;
  
  background-image: none;
  
}



:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}



progress {
  vertical-align: baseline;
}



::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}



[type='search'] {
  -webkit-appearance: textfield;
  
  outline-offset: -2px;
  
}



::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button;
  
  font: inherit;
  
}



summary {
  display: list-item;
}



blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}



textarea {
  resize: vertical;
}



input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1;
  
  color: #9ca3af;
  
}

input::placeholder,
textarea::placeholder {
  opacity: 1;
  
  color: #9ca3af;
  
}



button,
[role="button"] {
  cursor: pointer;
}



:disabled {
  cursor: default;
}



img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block;
  
  vertical-align: middle;
  
}



img,
video {
  max-width: 100%;
  height: auto;
}



[hidden] {
  display: none;
}

.yellow-bg {
  background-color: #FFF5C8;
  color:#885407
}

.button--round {
  background: #F1F4F9;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
}

.button--round:hover {
  background: #e1e6ee;
}

h1 {
  font-size: var(--trust-h1-size, 34px);
  line-height: var(--trust-h1-line-height, 41px);
  font-weight: var(--trust-h1-weight, 600);
  margin: var(--trust-h1-margin, 1.5rem 0);
}

h2 {
  font-size: var(--trust-h2-size, 28px);
  line-height: var(--trust-h2-line-height, 34px);
  font-weight: var(--trust-h2-weight, 600);
  margin: var(--trust-h2-margin, 1rem 0);
}

h3 {
  font-size: var(--trust-h3-size, 22px);
  line-height: var(--trust-h3-line-height, 28px);
  font-weight: var(--trust-h3-weight, 600);
  margin: var(--trust-h3-margin, 1rem 0);
}

h4 {
  font-size: var(--trust-h4-size, 16px);
  line-height: var(--trust-h4-line-height, 1.5rem);
  font-weight: var(--trust-h4-weight, 600);
  margin: var(--trust-h4-margin, 1rem 0);
}

h5 {
  font-size: var(--trust-h5-size, 14px);
  line-height: var(--trust-h5-line-height, 1.5rem);
  font-weight: var(--trust-h5-weight, 400);
  margin: var(--trust-h5-margin, 1rem 0);
}

a {
  font-size: var(--trust-a-size, 16px);
  line-height: var(--trust-a-line-height, 22px);
  font-weight: var(--trust-a-weight, 300);
  margin: var(--trust-a-margin, 0);
}

a:not(.button) {
  color: var(--trust-primary);
}

a:not(.button):hover {
  color: var(--trust-primary__hover);
  text-decoration-line: underline;
}

a:not(.button):focus {
  color: var(--trust-primary__hover);
  text-decoration-line: underline;
}

p.strong {
  font-weight: var(--trust-p-strong-weight, 600);
}

p {
  font-size: var(--trust-p-size, 16px);
  line-height: var(--trust-p-line-height, 22px);
  font-weight: var(--trust-p-weight, 300);
  margin: var(--trust-p-margin, 0);
}

p.strong {
  font-weight: var(--trust-p-strong-weight, 600);
}

.p.strong {
  font-weight: var(--trust-p-strong-weight, 600);
}

p > strong {
  font-weight: var(--trust-p-strong-weight, 600);
}

p.detail > strong {
  font-weight: var(--trust-detail-strong-weight, 600);
}

p.caption > strong {
  font-weight: var(--trust-caption-strong-weight, 600);
}

.caption.strong {
  font-weight: var(--trust-caption-strong-weight, 600);
}

.detail.strong {
  font-weight: var(--trust-detail-strong-weight, 600);
}

.button,
  .button--secondary,
  .button--default {
  
}

.button.strong,
  .button--secondary.strong,
  .button--default.strong {
  font-weight: var(--trust-p-strong-weight, 600);
}

.button,
  .button--secondary,
  .button--default {
  font-size: var(--trust-p-size, 16px);
  line-height: var(--trust-p-line-height, 22px);
  font-weight: var(--trust-p-weight, 300);
  margin: var(--trust-p-margin, 0);
  font-weight: var(--trust-p-strong-weight, 600);
  justify-content: center;
  border-radius: 8px;
  line-height: 20px;
  
  border-width: 2px;
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
  background-color: var(--trust-secondary);
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 14px;
  padding-right: 14px;
  color: var(--trust-primary);
}

.button:hover,
  .button--secondary:hover,
  .button--default:hover {
  border-color: var(--trust-primary);
  background-color: var(--trust-secondary__hover);
}

.button:active,
  .button--secondary:active,
  .button--default:active {
  --tw-brightness: brightness(.9);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}



a.button,
  a.button:active,
  a.button:hover {
  display: inline-flex;
  text-decoration-line: none;
}

.button--primary,
  .button--cta {
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 16px;
  padding-right: 16px;
  border-width: 0px;
  background-color: var(--trust-primary);
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.button--primary:hover,
  .button--cta:hover {
  background-color: var(--trust-primary__hover);
}

.button--primary:active,
  .button--cta:active {
  background-color: var(--trust-primary__active);
}

.button--tertiary,
  .button--flat {
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 16px;
  padding-right: 16px;
  border-width: 0px;
  background-color: transparent;
  color: var(--trust-primary);
}

.button--tertiary:hover,
  .button--flat:hover {
  background-color: var(--trust-secondary__hover);
}

.button--tertiary:active,
  .button--flat:active {
  --tw-brightness: brightness(.9);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.button--destructive {
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 16px;
  padding-right: 16px;
  border-width: 0px;
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.button--destructive:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity));
}

.button--destructive:active {
  --tw-bg-opacity: 1;
  background-color: rgb(153 27 27 / var(--tw-bg-opacity));
}

.button--destructive-flat {
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 16px;
  padding-right: 16px;
  border-width: 0px;
  background-color: transparent;
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity));
}

.button--destructive-flat:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity));
}

.button--destructive-flat:active {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity));
}

.button--utility {
  padding: 11px 15px;
  border-radius: 8px;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity));
}

.button--utility:hover {
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.button--utility:active {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}

.button--utility-flat {
  padding: 12px 16px;
  background-color: transparent;
  border-radius: 8px;
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity));
}

.button--utility-flat:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}

.button--utility-flat:active {
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}

.button--pill {
  border-radius: 50%;
  min-height: 44px;
  min-width: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-color: transparent;
  background-color: transparent;
  padding: 4px;
  color: var(--trust-primary);
}

.button--pill:hover {
  background-color: rgba(var(--trust-primary), 0.1);
  background-clip: padding-box;
  border-color: hsla(0, 0%, 100%, 0.4);
}

.button--link {
  
}

.button--link.strong {
  font-weight: var(--trust-p-strong-weight, 600);
}

.button--link {
  font-size: var(--trust-p-size, 16px);
  line-height: var(--trust-p-line-height, 22px);
  font-weight: var(--trust-p-weight, 300);
  margin: var(--trust-p-margin, 0);
  margin: 0;
  display: inline;
  border-width: 0px;
  background-color: transparent;
  padding: 0;
}

.button--link:hover,
  .button--link:active {
  background-color: transparent;
  text-decoration-line: underline;
}



.button--small.strong {
  font-weight: var(--trust-p-strong-weight, 600);
}

.button--small {
  font-size: var(--trust-p-size, 16px);
  line-height: var(--trust-p-line-height, 22px);
  font-weight: var(--trust-p-weight, 300);
  margin: var(--trust-p-margin, 0);
  font-weight: var(--trust-p-strong-weight, 600);
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 8px;
  padding-bottom: 8px;
  font-size: 12px;
  line-height: 16px;
}

.button--small.button--primary,
  .button--small.button--destructive,
  .button--small.button--destructive-flat,
  .button--small.button--order,
  .button--small.button--tertiary {
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 8px;
  padding-bottom: 8px;
}

.button--small.button--secondary {
  padding-top: 6px;
  padding-bottom: 6px;
}

.button--small.button--utility {
  padding: 7px 15px;
}

.button--small.button--pill {
  padding: 4px;
  min-height: 32px;
  min-width: 32px;
}

.button--small.button--link {
  padding: 0;
}



.button:disabled,
.button--is-disabled {
  background: #C3CCD9;
  border-color: #C3CCD9;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
  background-image: none;
  cursor: default;
  pointer-events: none;
}



.button--in-progress,
  a.button--in-progress:visited {
  pointer-events: none;
  border-color: transparent;
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
  background-size: 30px 30px !important;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity)) !important;
  background-image: linear-gradient(
      135deg,
      rgba(0, 0, 0, 0.05) 25%,
      transparent 0,
      transparent 50%,
      rgba(0, 0, 0, 0.05) 0,
      rgba(0, 0, 0, 0.05) 75%,
      transparent 0,
      transparent
    ) !important;
  animation: animate-inprogress 3s linear infinite;
}

@keyframes animate-inprogress {
  0% {
    background-position: 0 0;
  }

  to {
    background-position: 60px 0;
  }
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

.container {
  width: 100%;
}

@media (min-width: 480px) {
  .container {
    max-width: 480px;
  }
}

@media (min-width: 768px) {
  .container {
    max-width: 768px;
  }
}

@media (min-width: 990px) {
  .container {
    max-width: 990px;
  }
}

@media (min-width: 1280px) {
  .container {
    max-width: 1280px;
  }
}

@media (min-width: 1536px) {
  .container {
    max-width: 1536px;
  }
}

.p {
  font-size: var(--trust-p-size, 16px);
  line-height: var(--trust-p-line-height, 22px);
  font-weight: var(--trust-p-weight, 300);
  margin: var(--trust-p-margin, 0);
}

.p-strong {
  font-weight: var(--trust-p-strong-weight, 600);
}

.caption {
  font-size: var(--trust-caption-size, 14px);
  line-height: var(--trust-caption-line-height, 18px);
  font-weight: var(--trust-caption-weight, 300);
}

.detail {
  font-size: var(--trust-detail-size, 12px);
  line-height: var(--trust-detail-line-height, 16px);
  font-weight: var(--trust-detail-weight, 300);
}

.h1 {
  font-size: var(--trust-h1-size, 34px);
  line-height: var(--trust-h1-line-height, 41px);
  font-weight: var(--trust-h1-weight, 600);
  margin: var(--trust-h1-margin, 1.5rem 0);
}

.h3 {
  font-size: var(--trust-h3-size, 22px);
  line-height: var(--trust-h3-line-height, 28px);
  font-weight: var(--trust-h3-weight, 600);
  margin: var(--trust-h3-margin, 1rem 0);
}

.pointer-events-none {
  pointer-events: none;
}

.pointer-events-auto {
  pointer-events: auto;
}

.visible {
  visibility: visible;
}

.static {
  position: static;
}

.fixed {
  position: fixed;
}

.absolute {
  position: absolute;
}

.relative {
  position: relative;
}

.-left-\\[3\\.5rem\\] {
  left: -3.5rem;
}

.-right-\\[3\\.5rem\\] {
  right: -3.5rem;
}

.bottom-16 {
  bottom: 16px;
}

.left-0 {
  left: 0;
}

.left-1\\/2 {
  left: 50%;
}

.right-0 {
  right: 0;
}

.top-0 {
  top: 0;
}

.top-1\\/2 {
  top: 50%;
}

.top-\\[5rem\\] {
  top: 5rem;
}

.top-\\[7px\\] {
  top: 7px;
}

.z-0 {
  z-index: 0;
}

.z-10 {
  z-index: 10;
}

.z-20 {
  z-index: 20;
}

.z-50 {
  z-index: 50;
}

.z-\\[2\\] {
  z-index: 2;
}

.m-0 {
  margin: 0;
}

.m-16 {
  margin: 16px;
}

.m-8 {
  margin: 8px;
}

.m-auto {
  margin: auto;
}

.mx-8 {
  margin-left: 8px;
  margin-right: 8px;
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}

.my-16 {
  margin-top: 16px;
  margin-bottom: 16px;
}

.my-4 {
  margin-top: 4px;
  margin-bottom: 4px;
}

.my-8 {
  margin-top: 8px;
  margin-bottom: 8px;
}

.my-\\[56px\\] {
  margin-top: 56px;
  margin-bottom: 56px;
}

.mb-0 {
  margin-bottom: 0;
}

.mb-16 {
  margin-bottom: 16px;
}

.mb-24 {
  margin-bottom: 24px;
}

.mb-32 {
  margin-bottom: 32px;
}

.mb-4 {
  margin-bottom: 4px;
}

.mb-8 {
  margin-bottom: 8px;
}

.ml-8 {
  margin-left: 8px;
}

.ml-auto {
  margin-left: auto;
}

.mr-16 {
  margin-right: 16px;
}

.mr-24 {
  margin-right: 24px;
}

.mr-8 {
  margin-right: 8px;
}

.mt-0 {
  margin-top: 0;
}

.mt-16 {
  margin-top: 16px;
}

.mt-2 {
  margin-top: 2px;
}

.mt-4 {
  margin-top: 4px;
}

.mt-8 {
  margin-top: 8px;
}

.block {
  display: block;
}

.inline-block {
  display: inline-block;
}

.flex {
  display: flex;
}

.table {
  display: table;
}

.grid {
  display: grid;
}

.\\!hidden {
  display: none !important;
}

.hidden {
  display: none;
}

.h-10 {
  height: 10px;
}

.h-16 {
  height: 16px;
}

.h-20 {
  height: 20px;
}

.h-24 {
  height: 24px;
}

.h-32 {
  height: 32px;
}

.h-4 {
  height: 4px;
}

.h-40 {
  height: 40px;
}

.h-48 {
  height: 48px;
}

.h-6 {
  height: 6px;
}

.h-8 {
  height: 8px;
}

.h-96 {
  height: 96px;
}

.h-\\[130px\\] {
  height: 130px;
}

.h-\\[16rem\\] {
  height: 16rem;
}

.h-\\[2px\\] {
  height: 2px;
}

.h-\\[5rem\\] {
  height: 5rem;
}

.h-full {
  height: 100%;
}

.min-h-\\[4rem\\] {
  min-height: 4rem;
}

.w-10 {
  width: 10px;
}

.w-16 {
  width: 16px;
}

.w-20 {
  width: 20px;
}

.w-24 {
  width: 24px;
}

.w-32 {
  width: 32px;
}

.w-40 {
  width: 40px;
}

.w-8 {
  width: 8px;
}

.w-\\[130px\\] {
  width: 130px;
}

.w-\\[16rem\\] {
  width: 16rem;
}

.w-\\[5rem\\] {
  width: 5rem;
}

.w-fit {
  width: -moz-fit-content;
  width: fit-content;
}

.w-full {
  width: 100%;
}

.min-w-full {
  min-width: 100%;
}

.max-w-\\[100px\\] {
  max-width: 100px;
}

.max-w-\\[200px\\] {
  max-width: 200px;
}

.max-w-\\[300px\\] {
  max-width: 300px;
}

.max-w-\\[400px\\] {
  max-width: 400px;
}

.max-w-\\[500px\\] {
  max-width: 500px;
}

.max-w-\\[600px\\] {
  max-width: 600px;
}

.max-w-\\[700px\\] {
  max-width: 700px;
}

.max-w-\\[800px\\] {
  max-width: 800px;
}

.max-w-\\[900px\\] {
  max-width: 900px;
}

.max-w-lg {
  max-width: 32rem;
}

.flex-shrink-0 {
  flex-shrink: 0;
}

.shrink-0 {
  flex-shrink: 0;
}

.flex-grow {
  flex-grow: 1;
}

.grow-0 {
  flex-grow: 0;
}

.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-x-\\[-0\\%\\] {
  --tw-translate-x: -0%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-x-\\[-100\\%\\] {
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-x-\\[-1000\\%\\] {
  --tw-translate-x: -1000%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-x-\\[-200\\%\\] {
  --tw-translate-x: -200%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-x-\\[-300\\%\\] {
  --tw-translate-x: -300%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-x-\\[-400\\%\\] {
  --tw-translate-x: -400%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-x-\\[-500\\%\\] {
  --tw-translate-x: -500%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-x-\\[-600\\%\\] {
  --tw-translate-x: -600%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-x-\\[-700\\%\\] {
  --tw-translate-x: -700%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-x-\\[-800\\%\\] {
  --tw-translate-x: -800%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-x-\\[-900\\%\\] {
  --tw-translate-x: -900%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.scale-\\[115\\%\\] {
  --tw-scale-x: 115%;
  --tw-scale-y: 115%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.cursor-pointer {
  cursor: pointer;
}

.list-none {
  list-style-type: none;
}

.auto-rows-auto {
  grid-auto-rows: auto;
}

.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

.flex-row {
  flex-direction: row;
}

.flex-col {
  flex-direction: column;
}

.flex-nowrap {
  flex-wrap: nowrap;
}

.items-end {
  align-items: flex-end;
}

.items-center {
  align-items: center;
}

.justify-end {
  justify-content: flex-end;
}

.justify-center {
  justify-content: center;
}

.justify-between {
  justify-content: space-between;
}

.justify-around {
  justify-content: space-around;
}

.justify-items-center {
  justify-items: center;
}

.gap-16 {
  gap: 16px;
}

.gap-8 {
  gap: 8px;
}

.overflow-auto {
  overflow: auto;
}

.overflow-hidden {
  overflow: hidden;
}

.text-ellipsis {
  text-overflow: ellipsis;
}

.rounded {
  border-radius: 0.25rem;
}

.rounded-16 {
  border-radius: 16px;
}

.rounded-4 {
  border-radius: 4px;
}

.rounded-8 {
  border-radius: 8px;
}

.rounded-full {
  border-radius: 9999px;
}

.rounded-lg {
  border-radius: 0.5rem;
}

.rounded-t-lg {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}

.border {
  border-width: 1px;
}

.border-0 {
  border-width: 0px;
}

.border-2 {
  border-width: 2px;
}

.border-\\[1px\\] {
  border-width: 1px;
}

.border-\\[2px\\] {
  border-width: 2px;
}

.border-x-8 {
  border-left-width: 8px;
  border-right-width: 8px;
}

.border-b-8 {
  border-bottom-width: 8px;
}

.border-b-\\[1px\\] {
  border-bottom-width: 1px;
}

.border-solid {
  border-style: solid;
}

.border-none {
  border-style: none;
}

.border-bluegray {
  border-color: var(--trust-bluegray, #C3CCD9);
}

.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}

.border-green-300 {
  --tw-border-opacity: 1;
  border-color: rgb(134 239 172 / var(--tw-border-opacity));
}

.border-red-300 {
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity));
}

.border-red-400 {
  --tw-border-opacity: 1;
  border-color: rgb(248 113 113 / var(--tw-border-opacity));
}

.border-stepper {
  border-color: var(--trust-stepper, var(--trust-primary));
}

.border-stepper--hover {
  border-color: var(--trust-stepper__hover, var(--trust-primary__hover));
}

.border-yellow-300 {
  --tw-border-opacity: 1;
  border-color: rgb(253 224 71 / var(--tw-border-opacity));
}

.border-x-transparent {
  border-left-color: transparent;
  border-right-color: transparent;
}

.border-b-white {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(255 255 255 / var(--tw-border-opacity));
}

.bg-black\\/50 {
  background-color: rgb(0 0 0 / 0.5);
}

.bg-bluegray {
  background-color: var(--trust-bluegray, #C3CCD9);
}

.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}

.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}

.bg-green-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(134 239 172 / var(--tw-bg-opacity));
}

.bg-green-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity));
}

.bg-marble {
  --tw-bg-opacity: 1;
  background-color: rgb(246 248 251 / var(--tw-bg-opacity));
}

.bg-primary {
  background-color: var(--trust-primary);
}

.bg-red-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(252 165 165 / var(--tw-bg-opacity));
}

.bg-red-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity));
}

.bg-stepper {
  background-color: var(--trust-stepper, var(--trust-primary));
}

.bg-surface-primary {
  background-color: var(--trust-surface-primary);
}

.bg-surface-secondary {
  background-color: var(--trust-surface-secondary);
}

.bg-tip-box {
  background-color: var(--trust-tip-box, var(--trust-surface-primary));
}

.bg-transparent {
  background-color: transparent;
}

.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.bg-yellow-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 224 71 / var(--tw-bg-opacity));
}

.bg-yellow-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity));
}

.bg-none {
  background-image: none;
}

.fill-black {
  fill: #000;
}

.fill-icon-primary {
  fill: var(--trust-icon-primary);
}

.fill-primary {
  fill: var(--trust-primary);
}

.p-0 {
  padding: 0;
}

.p-16 {
  padding: 16px;
}

.p-8 {
  padding: 8px;
}

.px-16 {
  padding-left: 16px;
  padding-right: 16px;
}

.px-6 {
  padding-left: 6px;
  padding-right: 6px;
}

.px-8 {
  padding-left: 8px;
  padding-right: 8px;
}

.py-12 {
  padding-top: 12px;
  padding-bottom: 12px;
}

.py-2 {
  padding-top: 2px;
  padding-bottom: 2px;
}

.py-4 {
  padding-top: 4px;
  padding-bottom: 4px;
}

.pb-4 {
  padding-bottom: 4px;
}

.text-left {
  text-align: left;
}

.text-center {
  text-align: center;
}

.align-middle {
  vertical-align: middle;
}

.text-12 {
  font-size: 12px;
  line-height: 16px;
}

.text-14 {
  font-size: 14px;
  line-height: 18px;
}

.text-16 {
  font-size: 16px;
  line-height: 22px;
}

.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}

.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.font-bold {
  font-weight: 700;
}

.font-medium {
  font-weight: 500;
}

.font-normal {
  font-weight: 400;
}

.leading-16 {
  line-height: 16px;
}

.leading-18 {
  line-height: 18px;
}

.leading-20 {
  line-height: 20px;
}

.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity));
}

.text-green-800 {
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity));
}

.text-link {
  color: var(--trust-primary);
}

.text-primary {
  color: var(--trust-text-primary);
}

.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity));
}

.text-red-800 {
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity));
}

.text-secondary {
  color: var(--trust-text-secondary);
}

.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.text-yellow-800 {
  --tw-text-opacity: 1;
  color: rgb(133 77 14 / var(--tw-text-opacity));
}

.no-underline {
  text-decoration-line: none;
}

.opacity-40 {
  opacity: 0.4;
}

.shadow-3 {
  --tw-shadow: 0 6px 8px rgba(var(--gray-700-rgb), .23), 0 10px 20px rgba(var(--gray-700-rgb), .19);
  --tw-shadow-colored: 0 6px 8px var(--tw-shadow-color), 0 10px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.drop-shadow-md {
  --tw-drop-shadow: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.duration-200 {
  transition-duration: 200ms;
}

.duration-500 {
  transition-duration: 500ms;
}

.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.content-\\[\\\\\\'\\\\\\'\\] {
  --tw-content: \\'\\';
  content: var(--tw-content);
}

@media (min-width: 768px) {
  .md\\:h1 {
    font-size: var(--trust-h1-size, 34px);
    line-height: var(--trust-h1-line-height, 41px);
    font-weight: var(--trust-h1-weight, 600);
    margin: var(--trust-h1-margin, 1.5rem 0);
  }
}

.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}

.after\\:bottom-0::after {
  content: var(--tw-content);
  bottom: 0;
}

.after\\:left-0::after {
  content: var(--tw-content);
  left: 0;
}

.after\\:right-0::after {
  content: var(--tw-content);
  right: 0;
}

.after\\:top-0::after {
  content: var(--tw-content);
  top: 0;
}

.after\\:rounded-full::after {
  content: var(--tw-content);
  border-radius: 9999px;
}

.after\\:opacity-0::after {
  content: var(--tw-content);
  opacity: 0;
}

.after\\:shadow-\\[0_0_0_1rem_rgba\\(0\\2c 0\\2c 0\\2c 0\\.3\\)\\]::after {
  content: var(--tw-content);
  --tw-shadow: 0 0 0 1rem rgba(0,0,0,0.3);
  --tw-shadow-colored: 0 0 0 1rem var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.after\\:transition::after {
  content: var(--tw-content);
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.after\\:duration-300::after {
  content: var(--tw-content);
  transition-duration: 300ms;
}

.after\\:content-\\[\\"\\"\\]::after {
  --tw-content: "";
  content: var(--tw-content);
}

.hover\\:scale-125:hover {
  --tw-scale-x: 1.25;
  --tw-scale-y: 1.25;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-\\[115\\%\\]:hover {
  --tw-scale-x: 115%;
  --tw-scale-y: 115%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:border-gray-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity));
}

.hover\\:border-stepper--hover:hover {
  border-color: var(--trust-stepper__hover, var(--trust-primary__hover));
}

.hover\\:bg-white:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.hover\\:fill-primary--hover:hover {
  fill: var(--trust-primary__hover);
}

.hover\\:text-link--hover:hover {
  color: var(--trust-primary__hover);
}

.hover\\:underline:hover {
  text-decoration-line: underline;
}

.hover\\:brightness-75:hover {
  --tw-brightness: brightness(.75);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.hover\\:drop-shadow-md:hover {
  --tw-drop-shadow: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.focus\\:scale-\\[115\\%\\]:focus {
  --tw-scale-x: 115%;
  --tw-scale-y: 115%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.focus\\:border-2:focus {
  border-width: 2px;
}

.focus\\:border-primary:focus {
  border-color: var(--trust-primary);
}

.focus\\:text-link--hover:focus {
  color: var(--trust-primary__hover);
}

.focus\\:underline:focus {
  text-decoration-line: underline;
}

.focus\\:caret-primary:focus {
  caret-color: var(--trust-primary);
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:brightness-75:focus {
  --tw-brightness: brightness(.75);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.focus\\:drop-shadow-md:focus {
  --tw-drop-shadow: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.disabled\\:invisible:disabled {
  visibility: hidden;
}

@media (min-width: 480px) {
  .sm\\:mx-16 {
    margin-left: 16px;
    margin-right: 16px;
  }

  .sm\\:py-48 {
    padding-top: 48px;
    padding-bottom: 48px;
  }
}

@media (min-width: 768px) {
  .md\\:mb-0 {
    margin-bottom: 0;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:h-\\[230px\\] {
    height: 230px;
  }

  .md\\:h-\\[400px\\] {
    height: 400px;
  }

  .md\\:w-\\[230px\\] {
    width: 230px;
  }

  .md\\:w-\\[400px\\] {
    width: 400px;
  }

  .md\\:w-\\[600px\\] {
    width: 600px;
  }

  .md\\:w-fit {
    width: -moz-fit-content;
    width: fit-content;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:justify-end {
    justify-content: flex-end;
  }

  .md\\:rounded-lg {
    border-radius: 0.5rem;
  }

  .md\\:p-32 {
    padding: 32px;
  }

  .md\\:p-48 {
    padding: 48px;
  }
}
`